import { FC, useEffect, useState } from "react";
import { Grid, Container, Box, Divider } from "@material-ui/core";
import AdminHeader from "../SubComponents/AdminHeader";
import useStyles from "../Styles/LearnStyles";
import WalletStepper from "../ConnectWallet/WalletStepper";
import Footer from "../SubComponents/Footer";
import CongratComponent from "../Congrat";
import { useHistory } from "react-router";
import InvestStepper from "../Invest/InvestStepper";

const LearnCongrat: FC<any> = ({ stepperIndex }) => {
  const classes = useStyles();
  const [learnCompleteStep, setlearnCompleteStep] = useState(true);
  const [sendFundCompleteStep, setSendFundCompleteStep] = useState(false);
  const history = useHistory();

  useEffect(() => {
    if (history?.location?.state?.investData) {
      setSendFundCompleteStep(true);
    }
  }, [history?.location?.state?.investData]);

  return (
    <>
      <AdminHeader isProject={true} />
      {history?.location?.state?.investData ? (
        <InvestStepper sendFundCompleteStep={sendFundCompleteStep} />
      ) : (
        <WalletStepper
          nochange={true}
          stepperIndex={true}
          disableModals={false}
          learnCompleteStep={learnCompleteStep}
        />
      )}
      <Box mt={3}>
        <Divider />
      </Box>
      <Box className={classes.learnpages} component="section">
        <Container fixed>
          <Grid container justifyContent="center">
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <CongratComponent invest={history?.location?.state?.investData} allocatedTickets={history.location.state?.state?.allocatedTickets} />
            </Grid>
          </Grid>
        </Container>
      </Box>
      <Footer />
    </>
  );
};

export default LearnCongrat;
